/* Buy Now buttons from sections/buy-now-button.liquid: straight to checkout.

   A tap first reads the cart (/cart.js). If the variant in the page's own native product form is not
   in the cart, the tap sends exactly what that form holds, its variant and its quantity, to Shopify's
   /cart/add.js, the same request with the same body that the theme's Add to cart makes. If that
   variant is already in the cart, it is not added again: its line is set to quantity 1 through
   Shopify's /cart/change.js (Master, 2026-10-24: Add to cart then Buy Now, or Buy Now, Back and Buy
   Now again, reached checkout with 2). The tap goes to /checkout when Shopify confirms the add or the
   change. Every other line in the cart is left as it is and goes too.

   It creates no form, holds no variant id and builds no /cart/<variant> link. The form is the one
   the theme labels "Primary purchase area" (main-product's buy box), unless the shopper changed an
   option (on Jaw and Body Connection, the language) in the lower featured-product buy box last:
   then that box's own native form, labelled "Additional purchase area", is the one sent, so the
   language bought is the language chosen.

   WHILE A COURSE PACK SWITCH IS ON, THE SWITCHED-ON BOX'S OWN FORM IS SENT INSTEAD (Master, 2026-10-18
   and 2026-10-20: "while it is on, every Buy Now must put the Course Pack in the cart, not the page's
   own product"). With a switch on (snippets/nv-addon.liquid, snippets/jbc-addon.liquid), the page's own
   Add to cart and Buy it now are off the page and that box's native Shopify form is the only way to
   buy, so it is the form posted: the id in it is the one Shopify wrote into that form. The buy box's
   switch is read first, then the lower box's. If the switched-on box's button is missing or disabled,
   nothing is sent, so the page's own product is never added in its place. A page without such a
   switch, and a page whose switches are all off, sends the "Primary purchase area" form as before.

   If the native Add to cart is missing or disabled, for instance sold out, nothing happens and the
   link's own href scrolls to the buy box. If Shopify refuses the cart read, the add or the change, or
   does not answer within 20 seconds, the shopper is sent nowhere: the button stops loading and the
   page scrolls to the buy box. component-product-form.js is not used or changed. The page may hold
   several of these sections; this file listens once for all of them. */
(function () {
  if (window.buyNowCheckoutReady) { return; }
  window.buyNowCheckoutReady = true;

  var BUSY = 'bnc-busy';
  var CHECKOUT_URL = '/checkout';

  function nativeAddToCart() {
    return document.querySelector('form[action*="/cart/add"][aria-label="Primary purchase area"] [data-js-product-add-to-cart]')
        || document.querySelector('[data-sticky-purchase-area] form[action*="/cart/add"] [data-js-product-add-to-cart]')
        || document.querySelector('form[action*="/cart/add"] [data-js-product-add-to-cart]');
  }

  /* THE BUY BOX THE SHOPPER LAST CHOSE AN OPTION IN. A page can show its product twice, in the buy box
     and in the lower buy box, each with its own picker (on Jaw and Body Connection, the language). Buy
     Now sends the native form of the box whose picker the shopper changed last, so a language chosen in
     the lower box is the one bought. Until a picker changes, the buy box's own form is sent, as before.
     It only notes which box changed; it never writes a form, a variant or a quantity. */
  var lastChosenBox = null;
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest || !target.closest('product-variants')) { return; }
    var box = target.closest('product-page');
    if (box) { lastChosenBox = box; }
  }, true);

  function chosenAddToCart() {
    if (!lastChosenBox || !lastChosenBox.isConnected) { return null; }
    return lastChosenBox.querySelector('form[action*="/cart/add"]:not(.fah2__addon-form) [data-js-product-add-to-cart]');
  }

  /* The submit button of the form to send, read at the moment of the tap: a switched-on Course Pack
     box's own button, else the native Add to cart of the box the shopper last chose in, else the buy
     box's native Add to cart. */
  function buyButton() {
    var boxes = document.querySelectorAll('[data-cpk-addon] .fah2__addon');
    for (var i = 0; i < boxes.length; i++) {
      var toggle = boxes[i].querySelector('[data-fah2-addon-toggle]');
      if (toggle && toggle.checked) { return boxes[i].querySelector('.fah2__addon-buy .fah2__addon-atc'); }
    }
    return chosenAddToCart() || nativeAddToCart();
  }

  /* The theme's own cart routes: cart_url, cart_add_url (the one its Add to cart posts to) and
     cart_change_url. */
  function cartRoute(name, fallback) {
    var routes = window.KROWN && window.KROWN.settings && window.KROWN.settings.routes;
    return ((routes && routes[name]) || fallback) + '.js';
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: body
    });
  }

  function setBusy(link, on) {
    link.classList.toggle(BUSY, on);
    if (on) { link.setAttribute('aria-busy', 'true'); } else { link.removeAttribute('aria-busy'); }
  }

  function showBuyBox(link) {
    var href = link.getAttribute('href') || '';
    var box = href.charAt(0) === '#' && href.length > 1 ? document.getElementById(href.slice(1)) : null;
    if (box) { box.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) { return; }
    var link = target.closest('[data-buy-now-checkout]');
    if (!link) { return; }

    /* One tap is one add. A tap while the add is still running is ignored. */
    if (link.classList.contains(BUSY)) { event.preventDefault(); event.stopPropagation(); return; }

    var button = buyButton();
    var form = button && (button.form || button.closest('form'));
    if (!form) { return; }
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') { return; }

    event.preventDefault();
    event.stopPropagation();
    setBusy(link, true);

    var settled = false;
    function giveUp() {
      if (settled) { return; }
      settled = true;
      clearTimeout(timer);
      setBusy(link, false);
      showBuyBox(link);
    }
    var timer = setTimeout(giveUp, 20000);

    /* The variant is read from the form being sent, at the moment of the tap. */
    var data = new FormData(form);
    var variantId = String(data.get('id') || '');

    /* Already in the cart: that one line is set to 1. Not in the cart: the form is added as before.
       No other line is changed. */
    fetch(cartRoute('cart_url', '/cart'), { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) { throw new Error('cart ' + response.status); }
        return response.json();
      })
      .then(function (cart) {
        if (settled) { return null; }
        var items = (cart && cart.items) || [];
        for (var i = 0; i < items.length; i++) {
          if (String(items[i].variant_id) === variantId) {
            return post(cartRoute('cart_change_url', '/cart/change'),
              new URLSearchParams({ id: items[i].key, quantity: '1' }).toString());
          }
        }
        return post(cartRoute('cart_add_url', '/cart/add'), new URLSearchParams(data).toString());
      })
      .then(function (response) {
        if (settled || !response) { return; }
        if (!response.ok) { giveUp(); return; }
        settled = true;
        clearTimeout(timer);
        window.location.assign(CHECKOUT_URL);
      })
      .catch(giveUp);
  }, true);

  /* Back from checkout: a page the browser restores from memory must not keep spinning. */
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) { return; }
    var busy = document.querySelectorAll('[data-buy-now-checkout].' + BUSY);
    for (var i = 0; i < busy.length; i++) { setBusy(busy[i], false); }
  });
})();
